export const areUrlsEqual = (url1, url2) => {
  //  compare url, but without the query params
  return url1.split('?')[0] === url2.split('?')[0]
}
